import { Injectable } from '@angular/core';
import { ServiceType } from '../models/service-type.model';
import { Action, State, StateContext, Store } from '@ngxs/store';
import { AlertService } from 'src/app/shared/store/alert/alert.service';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { ServiceTypeService } from '../services/service-type.service';
import { ServiceTypeActions } from './service-type.actions';
import { MappingUtilsService } from 'src/app/services/utils/mapping-utils.service';

export class ServiceTypeStateModel {
  public serviceTypes: ServiceType[];
  public serviceTypesAll: ServiceType[];
  public error: string;
}

const defaults = {
  serviceTypes: [],
  serviceTypesAll: [],
  error: ''
};

@State<ServiceTypeStateModel>({
  name: 'serviceTypes',
  defaults,
})
@Injectable()
export class ServiceTypeState {
  constructor(
    private alertService: AlertService,
    private localizationService: LocalizationService,
    private serviceTypeService: ServiceTypeService,
    public store: Store
  ) {}

  @Action(ServiceTypeActions.GetServices)
  getServices(ctx: StateContext<ServiceTypeStateModel>, {}: ServiceTypeActions.GetServices) {
    const cachedServiceTypes = ctx.getState().serviceTypesAll;
    if (cachedServiceTypes && cachedServiceTypes.length > 0) {
      return ctx.dispatch(new ServiceTypeActions.GetServicesSuccess([...cachedServiceTypes]));
    }

    return this.serviceTypeService.getServices().subscribe({
      next: (response) =>
        ctx.dispatch(new ServiceTypeActions.GetServicesSuccess(response)),
      error: (error) =>
        ctx.dispatch(new ServiceTypeActions.Error(error)),
    });
  }

  @Action(ServiceTypeActions.GetServicesSuccess)
  getServicesSuccess(ctx: StateContext<ServiceTypeStateModel>, { serviceTypes }: ServiceTypeActions.GetServicesSuccess) {
    ctx.patchState({
      serviceTypesAll: serviceTypes.sort((a, b) => a.description.localeCompare(b.description))
     });
  }

  @Action(ServiceTypeActions.GetServicesBySchool)
  getServicesBySchool(ctx: StateContext<ServiceTypeStateModel>, { exerciseId, schoolId }: ServiceTypeActions.GetServicesBySchool) {
    return this.serviceTypeService.getServiceMapByExerciseAndSchool(exerciseId, schoolId).subscribe({
      next: (response) =>
        ctx.dispatch(new ServiceTypeActions.GetServicesBySchoolSuccess(response)),
      error: (error) =>
        ctx.dispatch(new ServiceTypeActions.Error(error)),
    });
  }

  @Action(ServiceTypeActions.GetServicesBySchoolSuccess)
  getServicesBySchoolSuccess(ctx: StateContext<ServiceTypeStateModel>, { serviceTypes }: ServiceTypeActions.GetServicesBySchoolSuccess) {
    ctx.patchState({
      serviceTypes: serviceTypes.sort((a, b) => a.description.localeCompare(b.description))
     });
  }

  @Action(ServiceTypeActions.Error)
  onErrorOccured(
    ctx: StateContext<ServiceTypeStateModel>,
    { error }: ServiceTypeActions.Error
  ) {
    ctx.patchState({
      error: error,
    });
    MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
  }

  private getTitle() {
    return this.localizationService.translate('labels.service');
  }
}
